import { useState, useEffect } from 'react'
import { useSearchParams } from 'react-router'
import { api } from '@api/client'

export function useSecureToken () {
  const [searchParams] = useSearchParams()
  const [isValidToken, setIsValidToken] = useState(false)
  const [isLoading, setIsLoading] = useState(true)
  const [tokenData, setTokenData] = useState(null)

  useEffect(() => {
    async function validateToken () {
      const token = searchParams.get('token')

      if (!token) {
        setIsValidToken(false)
        setIsLoading(false)
        return
      }

      try {
        const response = await api.post('/auth/validate-secure-token', {
          token
        })

        if (response.data.valid) {
          setIsValidToken(true)
          setTokenData(response.data)

          sessionStorage.setItem('secureToken', token)
        } else {
          setIsValidToken(false)
        }
      } catch (error) {
        console.error('Token validation failed:', error)
        setIsValidToken(false)
      } finally {
        setIsLoading(false)
      }
    }

    validateToken()
  }, [searchParams])

  return { isValidToken, isLoading, tokenData }
}
